//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoDatatableBasic from './demos/DemoDatatableBasic.vue'
import DemoDatatableDense from './demos/DemoDatatableDense.vue'
import DemoDatatableFixedHeader from './demos/DemoDatatableFixedHeader.vue'
import DemoDatatableGrouping from './demos/DemoDatatableGrouping.vue'
import DemoDatatableCellSlot from './demos/DemoDatatableCellSlot.vue'
import DemoDatatableExpandableRows from './demos/DemoDatatableExpandableRows.vue'
import DemoDatatableRowEditingViaDialog from './demos/DemoDatatableRowEditingViaDialog.vue'
import DemoDatatableCellEditingViaDialog from './demos/DemoDatatableCellEditingViaDialog.vue'
import DemoDatatableExternalPagination from './demos/DemoDatatableExternalPagination.vue'
import DemoDatatableKitchenSink from './demos/DemoDatatableKitchenSink.vue'
import DemoDatatableRowSelection from './demos/DemoDatatableRowSelection.vue'

// code
import {
  datatableBasic,
  datatableDense,
  datatableCellSlot,
  datatableFixedHeader,
  datatableGrouping,
  datatableExpandableRows,
  datatableRowEditingViaDialog,
  datatableCellEditingViaDialog,
  datatableExternalPagination,
  datatableKitchenSink,
  datatableRowSelection,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoDatatableBasic,
    DemoDatatableDense,
    DemoDatatableCellSlot,
    DemoDatatableFixedHeader,
    DemoDatatableGrouping,
    DemoDatatableExpandableRows,
    DemoDatatableRowEditingViaDialog,
    DemoDatatableCellEditingViaDialog,
    DemoDatatableExternalPagination,
    DemoDatatableKitchenSink,
    DemoDatatableRowSelection,
  },
  setup() {
    return {
      codeSnippets: {
        datatableBasic,
        datatableDense,
        datatableCellSlot,
        datatableFixedHeader,
        datatableGrouping,
        datatableExpandableRows,
        datatableRowEditingViaDialog,
        datatableCellEditingViaDialog,
        datatableExternalPagination,
        datatableKitchenSink,
        datatableRowSelection,
      },
    }
  },
}
